var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-flex align-center"},[(_vm.meta.img)?[_c('div',{staticClass:"brand-badge-mask ml-2",style:({
        width: _vm.size + 'px',
        height: _vm.size + 'px',
        backgroundColor: _vm.customColor || _vm.meta.colors[0],
        maskImage: `url(${_vm.meta.img})`,
        WebkitMaskImage: `url(${_vm.meta.img})`
      })})]:_c('v-icon',{staticClass:"ml-2",attrs:{"size":_vm.size,"color":_vm.customColor || _vm.meta.colors[0]}},[_vm._v(" mdi-"+_vm._s(_vm.meta.icon || _vm.meta.defaultIcon)+" ")]),(_vm.showTitle)?_c('span',{staticClass:"store-type-label font-weight-medium"},[_vm._v(" "+_vm._s(_vm.meta.title||_vm.meta?.type)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }